let m = require("mithril");

let clocks = require("./view/clocks");
let menu = require("./view/menu");

m.route(document.body, "/menu", {
	"/menu": {
		view: () => {
			return m(menu)
		}
	},
	"/clocks": {
		view: () => {
			return m(clocks)
		}
	}
})


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 4
// module chunks = 0